// Deliberately isolated from the existing Agent/Customer auth (utils/tokenUtils.jsx,
// utils/axiosInstance.jsx) — a Partner (marketplace business) is a completely separate identity
// from an Agent (referral reseller). Own axios instance, own localStorage key, own 401 handling.
import axios from "axios";
import baseURL from "../../../Services/Config";

const partnerAxios = axios.create({
  baseURL,
  timeout: 15000,
});

partnerAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("partner_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

partnerAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("partner_token");
      localStorage.removeItem("partner_profile");
      if (!window.location.pathname.startsWith("/partner/login")) {
        window.location.href = "/partner/login";
      }
    }
    return Promise.reject(error);
  }
);

export default partnerAxios;
